import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.member.list');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-member-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.member.list/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}`],
})
export class PortalMemberListComponent implements OnInit {
    public loading: boolean = false;
    public members: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 20;

    public search: any = { text: '', role: '', status: '' };
    public roles: string[] = ['admin', 'user'];
    public showCreateModal: boolean = false;
    public createData: any = { email: '', password: '', name: '', role: 'user', department: '', position: '' };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const params = new URLSearchParams();
        params.append('text', this.search.text);
        params.append('role', this.search.role);
        params.append('status', this.search.status);
        params.append('page', String(this.page));
        params.append('dump', String(this.dump));

        try {
            const res = await fetch('/api/member/list', { method: 'POST', body: params });
            const result = await res.json();
            if (res.ok) {
                this.members = result.data?.rows || [];
                this.total = result.data?.total || 0;
            }
        } catch (e) { }

        this.loading = false;
        await this.service.render();
    }

    public async filterByRole(role: string) {
        this.search.role = this.search.role === role ? '' : role;
        this.page = 1;
        await this.load();
    }

    public async filterByStatus(status: string) {
        this.search.status = this.search.status === status ? '' : status;
        this.page = 1;
        await this.load();
    }

    public async searchMembers() {
        this.page = 1;
        await this.load();
    }

    public async openCreate() {
        this.createData = { email: '', password: '', name: '', role: 'user', department: '', position: '' };
        this.showCreateModal = true;
        await this.service.render();
    }

    public async createMember() {
        if (!this.createData.email || !this.createData.password || !this.createData.name) {
            await this.service.modal.error("필수 항목을 모두 입력해주세요.");
            return;
        }

        const params = new URLSearchParams();
        for (const [k, v] of Object.entries(this.createData)) {
            params.append(k, String(v));
        }

        try {
            const res = await fetch('/api/member/create', { method: 'POST', body: params });
            const result = await res.json();
            if (res.ok) {
                await this.service.modal.success("멤버가 생성되었습니다.");
                this.showCreateModal = false;
                await this.load();
            } else {
                await this.service.modal.error(result.message || "생성 실패");
            }
        } catch (e) {
            await this.service.modal.error("서버 오류");
        }
    }

    public async changeRole(member: any, newRole: string) {
        const params = new URLSearchParams();
        params.append('user_id', member.id);
        params.append('role', newRole);
        await fetch('/api/member/change-role', { method: 'POST', body: params });
        await this.load();
    }

    public async toggleStatus(member: any) {
        const action = member.status === 'active' ? 'deactivate' : 'activate';
        const confirm = await this.service.modal.show({
            title: action === 'deactivate' ? '계정 비활성화' : '계정 활성화',
            message: `${member.name}님의 계정을 ${action === 'deactivate' ? '비활성화' : '활성화'}하시겠습니까?`,
            action: '확인', actionBtn: action === 'deactivate' ? 'error' : 'success',
            status: action === 'deactivate' ? 'error' : 'success'
        });
        if (!confirm) return;

        const params = new URLSearchParams();
        params.append('user_id', member.id);
        await fetch(`/api/member/${action}`, { method: 'POST', body: params });
        await this.load();
    }

    public async pageMove(page: number) {
        this.page = page;
        await this.load();
    }

    public get totalPages(): number {
        return Math.ceil(this.total / this.dump);
    }

    public roleClass(role: string) {
        switch (role) {
            case 'admin': return 'bg-purple-100 text-purple-700';
            case 'user': return 'bg-blue-100 text-blue-700';
            default: return 'bg-gray-100 text-gray-600';
        }
    }

    public statusClass(status: string) {
        return status === 'active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700';
    }
}

export default PortalMemberListComponent;